import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import AppBar from "../../components/AppBar/AppBar";
import {
  useExportProjectMappingsMutation,
  useProjectProgress,
} from "../hooks/useVocabQueries";

function ProgressBar({ label, value, total, color }) {
  const pct = total > 0 ? Math.round((value / total) * 100) : 0;
  return (
    <div>
      <div className="flex justify-between text-sm mb-1">
        <span className="text-gray-600 dark:text-gray-300">{label}</span>
        <span className="font-medium dark:text-white">{value} ({pct}%)</span>
      </div>
      <div className="h-2 rounded-full bg-gray-200 dark:bg-ramsalab-light-navy">
        <div className={`h-2 rounded-full ${color}`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}

export default function ProjectDashboardPage() {
  const { projectId } = useParams();

  const progressQuery = useProjectProgress({
    queryConfig: {
      queryKey: [projectId],
      apiParams: { projectId },
    },
  });

  const exportMutation = useExportProjectMappingsMutation({
    mutationConfig: {
      onSuccess: (blob) => {
        saveAs(blob, `vocab-mappings-project-${projectId}.csv`);
      },
    },
  });

  const progress = progressQuery.data;

  return (
    <div className="min-h-screen dark:bg-ramsalab-deep-navy">
      <AppBar />
      <header className="mx-auto max-w-3xl px-4 py-6 sm:px-6 lg:px-8">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
          Vocabulary mapping · Project #{projectId}
        </h1>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-8 sm:px-6 lg:px-8">
        {progressQuery.isLoading && <p className="text-gray-500">Loading progress…</p>}

        {progress && (
          <div className="rounded-xl border border-gray-200 dark:border-ramsalab-light-navy bg-white dark:bg-ramsalab-navy p-6 space-y-6">
            <div className="flex items-center justify-between">
              <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
                Mapping progress
              </h2>
              <button
                type="button"
                onClick={() => exportMutation.mutate({ projectId })}
                disabled={exportMutation.isLoading}
                className="rounded-md bg-ramsalab-teal-blue px-4 py-2 text-sm font-medium text-white"
              >
                Export CSV
              </button>
            </div>

            <p className="text-3xl font-bold text-gray-900 dark:text-white">
              {progress.mapped} / {progress.total} words mapped
            </p>

            <div className="space-y-4">
              <ProgressBar label="Mapped" value={progress.mapped} total={progress.total} color="bg-green-500" />
              <ProgressBar label="Partial" value={progress.partial} total={progress.total} color="bg-amber-500" />
              <ProgressBar label="Unmapped" value={progress.unmapped} total={progress.total} color="bg-gray-400" />
              <ProgressBar label="Skipped" value={progress.skipped} total={progress.total} color="bg-slate-400" />
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
